import script from "./KanbanRoutesStopsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./KanbanRoutesStopsTable.vue?vue&type=script&setup=true&lang=js"

import "./KanbanRoutesStopsTable.vue?vue&type=style&index=0&id=704aa980&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-704aa980"]])

export default __exports__